export const baseTheme = {
  colors: {
    primary: "#6675FF",
    secondary: "#F4F4F9",
    text: "#06001E",
    textLight: "#3D5781",
    neutral: "#FFFFFF",
    error: "#FF3E33",
    success: "#81c784",
    status: {
      metaText: "#1E293B",
      bodyText: "#2F4668",
      panelBorder: "#C5D0E0",
      panelMutedBg: "#F8FAFC",
      panelHighlightBg: "#F7F8FF",
      divider: "#E2E8F0",
      completed: "#2E7D32",
      inactiveBg: "#94A3B8",
      inactiveBorder: "#64748B",
      inactiveText: "#334155",
      pendingIcon: "#6B4A00",
      pendingChipBg: "#FFF3D6",
      pendingChipText: "#5C3D00",
      deniedChipBg: "#FFF1F0",
      deniedChipText: "#B71C1C",
      successChipBg: "#E8F5EC",
      successChipText: "#145C2B",
      successIcon: "#1B7F3B",
      refundChipBg: "#FFF8E6",
      refundChipText: "#8A6100",
      storeCreditBg: "#EEFBF1",
      reshipChipBg: "#F3E8FF",
      reshipChipText: "#5B21B6",
      iconMuted: "#475569",
    },
  },
  fonts: {
    main: "Open Sans, sans-serif",
    secondary: "Montserrat, sans-serif",
  },
};
